module.exports = __webpack_public_path__ + "static/media/expected_vs_actual.c5f0f234.mp4";